import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoEmail from 'eco-design/elements/eco-email';
import './index.scss';
import EcoImg from 'eco-design/base/eco-img';
import { subscribeFn } from '@/service/common';
export default function Content({ id, data = {} }: ContentServerProps) {
    const { pc, h5, title, subTitle, emarsysType } = data;
    const { locale } = getLocal();
    const prefixCls = 'index-join-email';

    const submitSubscribeHandle1 = ({ email }: any, callback: any) => {
        submitSubscribe(email, callback);
        return true;
    };
    const submitSubscribe = async (email: string, callback: any) => {
        const cookieDataA = subscribeCookie({
            sector_name: 'bottom subscribe',
            entry_position: 0,
        });
        const res = await subscribeFn(email, emarsysType || 'WEB_FOOTER', locale, cookieDataA);
        if (res?.code === '0') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: 'Subscribe',
                status: 'success',
                tag: 'Agree',
                __btn_id1: `temp-${id}`,
                __btn_id2: 'form-submit',
                __btn_type: 'common',
            });
            callback('success');
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: 'Subscribe',
                status: 'fail',
                tag: 'Agree',
            });
            callback('fail');
        }
        return true;
    };
    return (
        <GloLayout className={`editor-index-join-email`} id={id} data={data}>
            <div className={`eco-content-v2 ${prefixCls}-send-container`}>
                <div className={`${prefixCls}-send`}>
                    <div className={`${prefixCls}-send-l`}>
                        <div className={`${prefixCls}-send-title`}>{title}</div>
                        <div className={`${prefixCls}-send-desc`}>{subTitle}</div>
                    </div>
                    <div className={`${prefixCls}-send-r`}>
                        <EcoEmail contactListId={[]} onBeforeSendCallback={submitSubscribeHandle1} />
                    </div>
                </div>
                <EcoImg className={`${prefixCls}-bg-img`} pc={pc} h5={h5} />
            </div>
        </GloLayout>
    );
}
